import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectSubmitFormViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
ProjectSubmitFormViewTopBar.displayName = "ProjectSubmitFormViewTopBar"
